// @ts-nocheck -- will be removed once we migrate to React
import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { isDevelopingApp, macroCondition } from '@embroider/macros';

import domain from 'receivable-invoices-js/utils/shared-cookie-domain';

const COOKIE_MAX_AGE_SEC = 31622400; // number of seconds in 12 months

export default class DeviceManagerService extends Service {
  @service cookies;

  @tracked id;

  constructor() {
    super(...arguments);

    let id = this.cookies.read('deviceId');

    if (!id) {
      id = crypto.randomUUID();
      let options = {
        secure: macroCondition(!isDevelopingApp()) ? true : false,
        domain,
        maxAge: COOKIE_MAX_AGE_SEC,
      };
      this.cookies.write('deviceId', id, options);
    }

    this.id = id;
  }
}

declare module '@ember/service' {
  interface Registry {
    'device-manager': DeviceManagerService;
    deviceManager: DeviceManagerService;
  }
}
